import { Observable } from 'rxjs-es/Observable';
import $ from 'jquery';

$.widget("ips.hint", {
    options: {
        searchUrl: '/search/hint',
        searchInputSelector: '.search__input',
        searchHintSelector: '.search__hint',
        searchHintResultsSelector: '.search__hint-results',
        searchHintCloseButtonSelector: '.search__hint-close',
        searchHintResultsNumberSelector: '.search__results-number',

        searchBarOpenButtonSelector: '.search__btn-toggle',
        debug: false,
    },

    _vars: {},

    _debug: function() {
        if(this.options.debug) {
            console.log.apply(this,arguments);
        }
    },

    _openSearchBox: function(value) {
        if(!value) {
            value="";
        }
        this._vars.searchHint.hide();
        $(".search__form", this.element).addClass("open");
        this._vars.searchInput.val(value);
        this._vars.searchInput.focus();
    },

    _closeSearchBox: function () {
        this._vars.searchHint.hide();
        this._vars.searchInput.val("");
        this._vars.searchInput.blur();

        $(".search__form", this.element).removeClass("open");
    },

    _create: function() {
        this._debug("Create element");
        this._vars.searchInput = $(this.options.searchInputSelector, this.element);
        this._vars.searchHint = $(this.options.searchHintSelector, this.element);
        this._vars.searchHintResults = $(this.options.searchHintResultsSelector, this._vars.searchHint);
        this._vars.searchHintResultsNumber = $(this.options.searchHintResultsNumberSelector, this._vars.searchHint);
        this._vars.closeHintButton = $(this.options.searchHintCloseButtonSelector, this.element);
        this._vars.searchBarOpenButton = $(this.options.searchBarOpenButtonSelector, this.element);


        let closeSearchEvent = Observable.of(
            Observable.fromEvent(this._vars.closeHintButton, 'click'),
            Observable.fromEvent(this._vars.searchInput, 'keyup')
                .filter(event => event.key==='Escape' )
        ).flatMap(event => event).do(event => {
            this._closeSearchBox();
        });

        Observable.fromEvent(this._vars.searchBarOpenButton, 'click')
            .subscribe(event => { this._openSearchBox() });

        this._startSuggesting(closeSearchEvent);

        let stopKeys=[
            'Tab', 'Escape', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
            'F1','F2','F3','F4','F5','F6','F7','F8','F9','F10','F11','F12','F13','F14','F15',
            'Insert', 'Delete', 'Home', 'End', 'PageUp', 'PageDown',
            'CapsLock','NumLock','ScrollLock','Pause',
            'Enter','ContextMenu','Meta'
        ];

        Observable.fromEvent(document,'keydown')
            .filter(e => {
                let tagName = e.target.tagName.toLowerCase();
                return tagName!='input'
                    && tagName!='textarea'
                    && tagName!='button'
                    && e.which !== 0
                    && !e.ctrlKey && !e.metaKey && !e.altKey && !e.shiftKey && !e.metaKey
                    && stopKeys.indexOf(e.key)===-1;
            })
            .subscribe(e => {
                this._openSearchBox();
                this._debug(e);
            })
    },

    _startSuggesting: function(closeSearchEvent) {
        let searchInputInFocus = Observable.fromEvent(this._vars.searchInput, 'focus');
        let keyPresses = Observable.fromEvent(this._vars.searchInput, 'keyup');

        let s = searchInputInFocus
            .map(event =>
                keyPresses
                    .filter(event => event.keyCode!==27)
                    // .do(e => this._debug(e))
                    // .takeUntil(inputInactive)
                    .takeUntil(closeSearchEvent)
                    .debounceTime(300)
                    .distinctUntilChanged()
                    .map(event => this._vars.searchInput.val())
                    .map(query =>
                        Observable.ajax({
                            url: this.options.searchUrl+'?q='+query,
                            responseType: 'json',
                            crossDomain: true
                        }).retry(3).takeUntil(keyPresses)
                    ).concatAll()
            )
            .concatAll()
            .subscribe(
                data => {
                    this._vars.searchHintResults.empty();
                    this._vars.searchHintResultsNumber.text(data.response.total);
                    if(data.response.item.length>0) {
                        this._vars.searchHintResults.append(
                            $.map(data.response.item, i => {
                                if(i.image.length>0) {
                                    return '<li class="search__hint-item"><div class="search__hint-item-image"><img src="/images/'+i.image+'"/></div><a class="search__hint-item-link" href="/post/' + i.slug + '">' + i.title + '</a></li>';
                                }
                                return '<li class="search__hint-item"><a href="/post/' + i.slug + '">' + i.title + '</a></li>';
                            })
                        );
                        this._vars.searchHint.show();
                    }
                    else {
                        this._vars.searchHint.hide();
                    }
                    this._debug(data.response)
                },
                error => { this._debug(error) },
                () => this._debug("COMPLETED inputActive")
            );

        s.add(()=>this._debug("Unsubscribing"));

        return s;
    }

});


//////////////////
// WEBPACK FOOTER
// ./src/jquery.ips.searchhint.js
// module id = 352
// module chunks = 4